import React from "react";
import { Box, Flex, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
    const cardBg  = useColorModeValue("white",    "navy.800");
    const borderClr = useColorModeValue("gray.200", "whiteAlpha.100");

    return (
        <Flex minH="60vh" align="center" justify="center" px={{ base: "16px", md: "20px" }}>
            <Box
                bg={cardBg}
                borderRadius="16px"
                border="1px solid"
                borderColor={borderClr}
                p={{ base: "28px", md: "48px" }}
                maxW="480px"
                w="100%"
                textAlign="center"
            >
                <Icon as={CheckCircle2} boxSize="56px" color="green.400" mb="20px" />
                <Text fontSize="24px" fontWeight="700" color="gray.800" mb="10px">
                    Pagamento Riuscito
                </Text>
                <Text fontSize="15px" color="gray.500" lineHeight="1.7">
                    Grazie — il tuo pagamento è stato ricevuto. Puoi chiudere questa finestra.
                </Text>
            </Box>
        </Flex>
    );
}
